import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { LoggedInUser } from "../models/loggedInUser.model";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../environments/environment";

@Injectable({providedIn: 'root'})
export class AuthService {
    isAuthenticated = new BehaviorSubject<boolean>(false);
    user = new BehaviorSubject<any>({});
    isAuth = false;
    env = environment;

    constructor(private cookieService: CookieService) {}

    getCookie() {
        const authCookie = this.cookieService.get('auth');
        return authCookie;
    }

    // setCookie(data:any) {
    //     const tempUser = window.btoa(JSON.stringify(data));
    //     this.cookieService.set('auth', tempUser);
    // }

    deleteCookie() {
        let cookieName = 'auth';
        let cookieDomain = this.env.cookieDomain;
        // Delete the cookie
        document.cookie = `${cookieName}=; Path=/; Domain=${cookieDomain}; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure;`;
        
        cookieDomain = this.env.cookieBackendDomain;
        // Delete the cookie
        document.cookie = `${cookieName}=; Path=/; Domain=${cookieDomain}; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure;`;

        this.cookieService.delete('auth');
    }

    isAuthenticatedUser(): boolean {
        return this.isAuth;
    }

    getLoggedInUser() {
        //this.setCookie();
        var usercookie = this.getCookie();
        if(usercookie){
            const decodedData = window.atob(this.getCookie());
            var extractedData = JSON.parse(decodedData);
            // extractedData.data.user_id = 309;
            // this.setCookie(extractedData);
            const currentUser = new LoggedInUser(extractedData.auth, extractedData.data, extractedData.access_token);
            this.user.next(currentUser);
            this.isAuthenticated.next(true);
            this.isAuth = true;
        }else{
            this.isAuth = false;
        }
    }

    logOut() {
        this.deleteCookie();
        this.isAuthenticated.next(false);
        this.isAuth = false;
    }
}